<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">
                            {{checkModuleIndex('WLADJ', 'R', constAccessType.view, '', -1)}} {{this.getLanguage["WLAJ"]["WLAJR"]}}
                        </h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="!hideBrand">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <customtreeselect :multiple="false"
                                            :options="dd_agentgroup"
                                            :flat="true"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            v-model="str_FV[0].FV"
                                            @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   :opens="!hideBrand ? 'center' : 'right'"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.startDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.endDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" ref="search" class='searchBtn' size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>


            <div class="table-wrapper with_page">
                <header class="table-header">
                    <strong>
                        {{this.getLanguage["WLAJ"]["WLAJRL"]}}
                    </strong>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{getLanguage[["GL"]]["NO"]}}</th>
                                <th>{{ getLanguage["GL"]["ACT"] }}</th>
                                <th v-if="!hideBrand">{{ getLanguage["AFF"]["BN"] }}</th>
                                <th class="tableCtnCenter">{{ getLanguage['MEM']['CI'] }}</th>
                                <th>{{ getLanguage["GL"]["SD"] }}</th>
                                <th>{{ getLanguage["GL"]["ED"] }}</th>
                                <th class="tableCtnRight">{{ getLanguage["WLAJ"]["NETAMT"] }}</th>
                                <th>{{ getLanguage["WLAJ"]["SODT"] }}</th>
                                <th>{{ getLanguage["WLAJ"]["SOBY"] }}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{getLanguage[["GL"]]["NO"]}}</th>
                                <th>{{ getLanguage["GL"]["ACT"] }}</th>
                                <th v-if="!hideBrand">{{ getLanguage["AFF"]["BN"] }}</th>
                                <th class="tableCtnCenter">{{ getLanguage['MEM']['CI'] }}</th>
                                <th>{{ getLanguage["GL"]["SD"] }}</th>
                                <th>{{ getLanguage["GL"]["ED"] }}</th>
                                <th class="tableCtnRight">{{ getLanguage["WLAJ"]["NETAMT"] }}</th>
                                <th>{{ getLanguage["WLAJ"]["SODT"] }}</th>
                                <th>{{ getLanguage["WLAJ"]["SOBY"] }}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_SignOffSummaryList.length == 0">{{ this.getLanguage['GL']['NR'] }}</td>
                        <tr v-for="(data,index) in arr_SignOffSummaryList" :key="data.I" :class="{'highlight': (data.I == selectedRow)}">
                            <td>{{ CountItem(index+1)}}</td>
                            <td class="kema-eft">
                                <div v-if="data.RS == 2 && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" class="custom_tooltip">
                                    <i @click="DisplayGPI(data.I, data.SOTS, data.CI, data.AGI, formatDateTime(data.DF, 'YYYY-MM-DD', 'YYYY-MM-DD'), formatDateTime(data.DT, 'YYYY-MM-DD', 'YYYY-MM-DD'));selectRow(data.I)" class="cil-description"></i>
                                    <span class="tooltiptext">{{getLanguage["BTN"]["V"]}}</span>
                                </div>
                                <div v-else-if="data.RS == 2 && (isSENS == 1 && data.AGI != curAGI)" class="custom_tooltip">
                                    <i class="cil-description"></i>
                                    <span class="tooltiptext">{{getLanguage["BTN"]["V"]}}</span>
                                </div>
                            </td>
                            <td v-if="!hideBrand">{{ data.GN }}</td>
                            <td class="tableCtnCenter">{{ data.CN }}</td>
                            <td>{{ formatDateTime(data.DF, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td>{{ formatDateTime(data.DT, "YYYY-MM-DD", "DD MMM YYYY") }}&nbsp;23:59:59</td>
                            <td class="tableCtnRight">
                                <span v-if="!checkWholeNumber(data.NA)" :class="data.NA > 0? 'positive-number': 'negative-number'">
                                    {{ formatNumber(data.NA, 0, data.CS) }}
                                </span>
                                <span v-else :class="data.NA > 0? 'positive-number': 'negative-number'">
                                    {{ formatNumber(data.NA, 2, data.CS) }}
                                </span>
                            </td>
                            <td>{{ formatDateTime(data.SOTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td>{{ data.UB }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div>&nbsp;</div>
            </div>
            <div class="table-wrapper" v-if="arr_displayGPI.length>0">
                <header class="table-header">
                    <span>
                        <span><i class="cil-pin"></i>={{this.getLanguage["WLAJ"]["NE"]}}</span>&nbsp;&nbsp;&nbsp;<span><i class="cil-warning"></i>={{this.getLanguage["WLAJ"]["ADJ"]}}</span>&nbsp;&nbsp;
                        <button @click="ShowDetails();" id="hide-seen" type="button" class="btn btn-outline-primary btn-sm">
                            {{button.text}}
                        </button>
                    </span>
                </header>
                <template>
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th rowspan="2">{{this.getLanguage["GL"]["NO"]}}</th>
                                <th rowspan="2">{{this.getLanguage['GL']['AGT']}}/ <span class="tableCtnRight">{{this.getLanguage['MEM']['U']}}</span></th>
                                <th rowspan="2" v-if="!hideBrand">{{this.getLanguage['MEM']['CI']}}</th>
                                <th rowspan="2">{{this.getLanguage['MEM']['ACTM']}}</th>
                                <th colspan="2" v-if="this.bool_showDetails" id="nestedTable">{{this.getLanguage["BETRPT"]["DPT"]}}</th>
                                <th colspan="2" v-if="this.bool_showDetails" id="nestedTable">{{this.getLanguage["BETRPT"]["WTH"]}}</th>
                                <th colspan="2" v-if="this.bool_showDetails" id="nestedTable">{{this.getLanguage["BETRPT"]["BNS"]}}</th>
                                <th colspan="2" v-if="this.bool_showDetails" id="nestedTable">{{this.getLanguage["BETRPT"]["ARB"]}}</th>
                                <th colspan="2" v-if="this.bool_showDetails" id="nestedTable">{{this.getLanguage["BETRPT"]["AFF"]}}</th>
                                <th colspan="2" v-if="this.bool_showDetails" id="nestedTable">{{this.getLanguage["BETRPT"]["DLS"]}}</th>
                                <th colspan="2" v-if="this.bool_showDetails" id="nestedTable">{{this.getLanguage["BETRPT"]["RFF"]}}</th>
                                <th colspan="4" id="nestedTable">{{this.getLanguage["BETRPT"]["BET"]}}</th>
                                <th colspan="2" id="nestedTable">{{this.getLanguage["BETRPT"]["SHR"]}}</th>
                                <th rowspan="2">{{this.getLanguage["BETRPT"]["TWL"]}}</th>
                                <th colspan="2" id="nestedTable">{{this.getLanguage["BETRPT"]["ADJM"]}}</th>
                                <th rowspan="2">{{this.getLanguage["WLAJ"]["NEW"]}}&nbsp;{{this.getLanguage["BETRPT"]["TWL"]}}</th>
                            </tr>
                            <tr>
                                <th id="nestedTableR2" v-if="this.bool_showDetails" class="textAlignCenter">#</th>
                                <th id="nestedTableR2" v-if="this.bool_showDetails" class="textAlignCenter">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" v-if="this.bool_showDetails" class="textAlignCenter">#</th>
                                <th id="nestedTableR2" v-if="this.bool_showDetails" class="textAlignCenter">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" v-if="this.bool_showDetails" class="textAlignCenter">#</th>
                                <th id="nestedTableR2" v-if="this.bool_showDetails" class="textAlignCenter">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" v-if="this.bool_showDetails" class="textAlignCenter">#</th>
                                <th id="nestedTableR2" v-if="this.bool_showDetails" class="textAlignCenter">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" v-if="this.bool_showDetails" class="textAlignCenter">#</th>
                                <th id="nestedTableR2" v-if="this.bool_showDetails" class="textAlignCenter">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" v-if="this.bool_showDetails" class="textAlignCenter">#</th>
                                <th id="nestedTableR2" v-if="this.bool_showDetails" class="textAlignCenter">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" v-if="this.bool_showDetails" class="textAlignCenter">#</th>
                                <th id="nestedTableR2" v-if="this.bool_showDetails" class="textAlignCenter">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter">#</th>
                                <th id="nestedTableR2" class="textAlignCenter">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter">{{this.getLanguage["BETRPT"]["TRO"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter">{{this.getLanguage["BETRPT"]["WNL"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter">{{this.getLanguage["WLBMRPT"]["PWL"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter">{{this.getLanguage["WLBMRPT"]["AWL"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter">#</th>
                                <th id="nestedTableR2" class="textAlignCenter">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="this.bool_showDetails">
                                <tr v-for="(data_list,index) in arr_displayGPI" :class="data_list.P < 0? 'newDataRow': ''">
                                    <!-- :class="data_list.P < 0? 'highlightRow': ''">  <td class="tableCtnRight"><span v-if="data_list.P < 0">&nbsp;</span><span v-else>{{current_no.next().value}}</span></td>-->
                                    <td class="tableCtnRight"><span v-if="data_list.P<0" class="float-left"><i class="cil-pin"></i></span><span v-else-if="data_list.P==0" class="float-left"><i class="cil-warning"></i></span>{{ CountItem(index+1) }}</td>
                                    <td>{{ data_list.U }}</td>
                                    <td>{{ data_list.CN }}</td>
                                    <td>{{ data_list.AM }}</td>
                                    <td class="tableCtnRight"><span v-if="Math.abs(data_list.DC)!=0">{{ formatNumber(data_list.DC, 0) }}</span><span v-else>-</span></td>
                                    <td class="tableCtnRight"><span class="positive-number currency" :abbr="data_list.DA" v-if="Math.abs(data_list.DA)!=0">{{ formatNumber(data_list.DA , 2) }}</span><span v-else>-</span></td>
                                    <td class="tableCtnRight"><span v-if="Math.abs(data_list.WC)!=0">{{ formatNumber(data_list.WC , 0) }}</span><span v-else>-</span></td>
                                    <td class="tableCtnRight"><span class="negative-number" v-if="Math.abs(data_list.WA)!=0">{{ formatNumber(data_list.WA , 2) }}</span><span v-else>-</span></td>
                                    <td class="tableCtnRight"><span v-if="Math.abs(data_list.BNC)!=0">{{ formatNumber(data_list.BNC , 0) }}</span><span v-else>-</span></td>
                                    <td class="tableCtnRight"><span class="negative-number" v-if="Math.abs(data_list.BNA)!=0">{{ formatNumber(data_list.BNA , 2) }}</span><span v-else>-</span></td>
                                    <td class="tableCtnRight"><span v-if="Math.abs(data_list.ARC)!=0">{{ formatNumber(data_list.ARC , 0) }}</span><span v-else>-</span></td>
                                    <td class="tableCtnRight"><span class="negative-number" v-if="Math.abs(data_list.ARA)!=0">{{ formatNumber(data_list.ARA , 2) }}</span><span v-else>-</span></td>
                                    <td class="tableCtnRight"><span v-if="Math.abs(data_list.AC)!=0">{{ formatNumber(data_list.AC , 0) }}</span><span v-else>-</span></td>
                                    <td class="tableCtnRight"><span class="negative-number" v-if="Math.abs(data_list.AA)!=0">{{ formatNumber(data_list.AA , 2) }}</span><span v-else>-</span></td>
                                    <td class="tableCtnRight"><span v-if="Math.abs(data_list.DLSC)!=0">{{ formatNumber(data_list.DLSC, 0) }}</span><span v-else>-</span></td>
                                    <td class="tableCtnRight"><span class="positive-number currency" :abbr="data_list.DLSA" v-if="Math.abs(data_list.DLSA)!=0">{{ formatNumber(data_list.DLSA , 2) }}</span><span v-else>-</span></td>
                                    <td class="tableCtnRight"><span v-if="Math.abs(data_list.RC)!=0">{{ formatNumber(data_list.RC, 0) }}</span><span v-else>-</span></td>
                                    <td class="tableCtnRight"><span class="positive-number currency" :abbr="data_list.RA" v-if="Math.abs(data_list.RA)!=0">{{ formatNumber(data_list.RA , 2) }}</span><span v-else>-</span></td>
                                    <td class="tableCtnRight">{{ formatNumber(data_list.BC, 0) }}</td>
                                    <td class="tableCtnRight">{{ formatNumber(data_list.BA, 2) }}</td>
                                    <td class="tableCtnRight">{{ formatNumber(data_list.BT, 2) }}</td>
                                    <td class="positive-number tableCtnRight currency" :abbr="data_list.BWL">{{ formatNumber(data_list.BWL, 2) }}</td>
                                    <td class="positive-number tableCtnRight currency" :abbr="data_list.SPWL">{{ formatNumber(data_list.SPWL, 2) }}</td>
                                    <td class="positive-number tableCtnRight currency" :abbr="data_list.SHWL">{{ formatNumber(data_list.SHWL, 2) }}</td>
                                    <td class="positive-number tableCtnRight currency" :abbr="data_list.TWL">{{ formatNumber(data_list.TWL, 2) }}</td>
                                    <td v-if="data_list.GPI==0" class="tableCtnRight">
                                        {{ formatNumber(WalletAdjustmentCount, 0) }}
                                    </td>
                                    <td v-else>
                                        <span v-if="Math.abs(data_list.AMC)!=0">{{ formatNumber(data_list.AMC, 0) }}</span>
                                        <span v-else>-</span>
                                    </td>
                                    <td v-if="data_list.GPI==0" class="tableCtnRight">
                                        <span class="positive-number currency" :abbr="WalletAdjustmentAmt" v-if="Math.abs(WalletAdjustmentAmt)!=0">{{ formatNumber(WalletAdjustmentAmt, 2) }}</span><span v-else>-</span>
                                    </td>
                                    <td v-else class="tableCtnRight">
                                        <span class="positive-number currency" :abbr="data_list.AMA" v-if="Math.abs(data_list.AMA)!=0">{{ formatNumber(data_list.AMA, 2) }}</span><span v-else>-</span>
                                    </td>
                                    <td v-if="data_list.GPI==0" class="tableCtnRight">
                                        <span class="positive-number currency" :abbr="WalletNewTotalNet">
                                            {{ formatNumber(WalletNewTotalNet, 2) }}
                                        </span>
                                    </td>
                                    <td v-else class="tableCtnRight">
                                        <span class="positive-number currency" :abbr="data_list.AMA+data_list.TWL" v-if="Math.abs(data_list.AMA+data_list.TWL)!=0">{{ formatNumber(data_list.AMA+data_list.TWL, 2) }}</span><span v-else>-</span>
                                    </td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr v-for="(data_list,index) in arr_displayGPI" :class="data_list.P < 0? 'newDataRow': ''">
                                    <!--  <td class="tableCtnRight"><span v-if="data_list.P < 0">&nbsp;</span><span v-else>{{current_no.next().value}}</span></td>-->
                                    <td class="tableCtnRight"><span v-if="data_list.P<0" class="float-left"><i class="cil-pin"></i></span><span v-else-if="data_list.P==0" class="float-left"><i class="cil-warning"></i></span>{{ CountItem(index+1) }}</td>
                                    <td>{{ data_list.U }}</td>
                                    <td>{{ data_list.AM }}</td>
                                    <td>{{ data_list.CN }}</td>
                                    <td class="tableCtnRight">{{ formatNumber(data_list.BC, 0) }}</td>
                                    <td class="tableCtnRight">{{ formatNumber(data_list.BA, 2) }}</td>
                                    <td class="tableCtnRight">{{ formatNumber(data_list.BT, 2) }}</td>
                                    <td class="positive-number tableCtnRight currency" :abbr="data_list.BWL">{{ formatNumber(data_list.BWL, 2) }}</td>
                                    <td class="positive-number tableCtnRight currency" :abbr="data_list.SPWL">{{ formatNumber(data_list.SPWL, 2) }}</td>
                                    <td class="positive-number tableCtnRight currency" :abbr="data_list.SHWL">{{ formatNumber(data_list.SHWL, 2) }}</td>
                                    <td class="positive-number tableCtnRight currency" :abbr="data_list.TWL">{{ formatNumber(data_list.TWL, 2) }}</td>
                                    <td v-if="data_list.GPI==0" class="tableCtnRight AdjustedRow" :abbr="data_list.P">
                                        {{ formatNumber(WalletAdjustmentCount, 0) }}
                                    </td>
                                    <td v-else class="tableCtnRight AdjustedRow" :abbr="data_list.P">
                                        <span v-if="Math.abs(data_list.AMC)!=0">{{ formatNumber(data_list.AMC, 0) }}</span><span v-else>-</span>
                                    </td>
                                    <td v-if="data_list.GPI==0" class="tableCtnRight AdjustedRow" :abbr="data_list.P">
                                        <span class="positive-number currency" :abbr="WalletAdjustmentAmt" v-if="Math.abs(WalletAdjustmentAmt)!=0">{{ formatNumber(WalletAdjustmentAmt, 2) }}</span><span v-else>-</span>
                                    </td>
                                    <td v-else class="tableCtnRight AdjustedRow" :abbr="data_list.P">
                                        <span class="positive-number currency" :abbr="data_list.AMA" v-if="Math.abs(data_list.AMA)!=0">{{ formatNumber(data_list.AMA , 2) }}</span><span v-else>-</span>
                                    </td>
                                    <td v-if="data_list.GPI==0" class="tableCtnRight">
                                        <span class="positive-number currency" :abbr="WalletNewTotalNet">
                                            {{ formatNumber(WalletNewTotalNet, 2) }}
                                        </span>
                                    </td>
                                    <td v-else class="tableCtnRight">
                                        <span class="positive-number currency" :abbr="data_list.AMA+data_list.TWL" v-if="Math.abs(data_list.AMA+data_list.TWL)!=0">{{ formatNumber(data_list.AMA+data_list.TWL, 2) }}</span><span v-else>-</span>
                                    </td>
                                    <!--  <td class="tableCtnRight"><span class="positive-number currency" :abbr="data_list.AMA+data_list.TWL" v-if="Math.abs(data_list.AMA+data_list.TWL)!=0">{{ formatNumber(data_list.AMA+data_list.TWL, 2) }}</span><span v-else>-</span></td> -->
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { required } from "vuelidate/lib/validators";
    import { constAccessType, constRequestStatus, loadingFullScreen } from '@/modules/Constant.js';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
    import Treeselect from '@riophae/vue-treeselect';
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters } from 'vuex';
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import DateRangePicker from 'vue2-daterange-picker';
    import Vue from 'vue'
    import VueMonthlyPicker from 'vue-monthly-picker';


    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            VueMonthlyPicker,
        },
        data() {
            return {
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSummary: true,
                bool_showDetails: false,
                bool_showSearchBar: true,
                bool_isAMV: false,
                seen: false,
                current_no: this.sp_no(),
                //  int_RC: 100, //Row Count
                //   int_Total: 0,
                //  int_Page: 1,
                //  int_IC: 1, // Item Count
                //  int_TP: 1, //Total Page

                // int_adjustedRows: 0,
                arr_reportList: [],
                arr_displayGPI: [],
                selectedRow: null,
                str_FV: [
                    { F: "AGI" },
                    { F: "BM", FV: moment(new Date(new Date().getFullYear(), new Date().getMonth())) }
                ], //Filter Value
                arr_SignOffSummaryList: [],
                dd_agentgroup: [],
                constAccessType: constAccessType,
                searchCreatedTS: { startDate: this.getMonthStartDate(), endDate: this.getMonthEndDate() },
                sc_daterange: { startDate: null, endDate: null },
                button: {
                    text: "",
                },
                hideBrand: false,
            }
        },
        computed: {
            ...mapGetters("Language", ["getLanguage"]),
            ...mapGetters('UserInfo', ['getUserMemberSC', 'getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
            currencySymbol: function () {
                var CS = "";
                this.arr_SignOffSummaryList.forEach(e => {
                    if (e.CS!=null) {
                        CS= e.CS;
                    }

                });
                return CS;

            },
            WalletNewTotalNet: function () {
                var sum = 0;
                var WalletTWL = 0;
                this.arr_displayGPI.forEach(e => {
                    sum += e.AMA;
                });
                /*
                if (this.arr_displayGPI.length > 0) {
                    var arrayLength = this.arr_displayGPI.length;
                    for (let i = 0; i < arrayLength; i++) {
                        if (this.arr_displayGPI[i].ISOC != null) {
                            return this.arr_displayGPI[i].ISOC;
                        }
                    }
                }
                */
                if (this.arr_displayGPI.length > 0) {
                    if (this.arr_displayGPI[0].GPI == 0) {
                        WalletTWL = this.arr_displayGPI[0].TWL;
                    }
                }
                return sum + WalletTWL;
            },
            WalletAdjustmentCount: function () {
                var sum = 0;
                this.arr_displayGPI.forEach(e => { // able to loop all as mainWallet from DB is set 0
                    sum += e.AMC;
                });

                return sum;
            },
            WalletAdjustmentAmt: function () {
                var sum = 0;
                this.arr_displayGPI.forEach(e => { // able to loop all as mainWallet from DB is set 0
                    sum += e.AMA;
                });
                return sum;
            },
        },
        created() {
            this.$parent.showSubMenu = "R";
            this.$parent.showSubSubMenu = 'RS3';
            this.$parent.showActiveMenu = "R.WLADJ";

            this.hideBrand = this.getUserInfo.IHAGIF;
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            this.str_FV[0].FV = this.$route.query.agi;
            this.button.text = this.getLanguage["WLAJ"]["SDT"];

            this.getAgentGroup();
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getMainList();
            },
        },
        methods: {
            //...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            selectRow(WhichRow) {
                this.selectedRow = WhichRow;
            },
            DateTimeChange_2(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchCreatedTS.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.searchCreatedTS.endDate = "";
                    }
                }
            },
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[2].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[2].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[2].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[2].FV.endDate = "";
                    }
                }
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('CPR', 'R', type); // 2021-12-10 need to modify this
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0/1`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.dd_agentgroup = d.dropdownlist;
                        }
                        else {
                            that.dd_agentgroup = null;
                        }
                    });
            },
            AgentGroupChangefs(value) {

                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                    }
                    this.getDataApi(`/api/dd/dn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_dofs = d.dropdownlist
                            }
                        });
                }
                else {
                    this.str_FV[0].FV = null;
                }
            },
            ValidationErrMsg(value, langKey = "") {
                if (this.bool_CV) {
                    var validateObj = this.$v.obj_ab[value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["CPR"][langKey]);
                    }
                }
            },
            getMainList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = '';
                var agi = '';


                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                temp_ += this.str_FV[i].FV[x];
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'BM' && this.str_FV[i].FV != '') {
                            // var from_date = this.parseDateToJsonString(this.str_FV[i].FV);
                            // var to_date = moment(from_date).endOf('month').format('YYYY-MM-DD hh:mm');
                            // path += "&f[CTS_from]=" + from_date;
                            // path += "&f[CTS_to]=" + to_date;


                            if (this.searchCreatedTS) {

                                if (this.searchCreatedTS.startDate != "") {
                                    path += "&f[STS_from]=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                                }

                                if (this.searchCreatedTS.endDate != "") {
                                    path += "&f[STS_to]=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                                }

                            }

                        }
                        else if (this.str_FV[i].F == 'AGI' && this.str_FV[i].FV != '') {
                            var agi = 0;
                            var value = this.str_FV[i].FV;
                            if (value != "") {
                                agi = value.split("-")[1];
                            }
                            path += "&f[AGI]=" + agi;
                        }
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };

                this.getDataApi(`api/wlaj/signoff/list?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_SignOffSummaryList = d.D.Items;
                            that.resizeTableHead();
                        }
                    });
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            sp_no: function* () {
                let id = 0
                while (true) {
                    yield id;
                    id++;
                }
            },
            newSearch() {
                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        var z = this.set90daysDateSearch(this.searchCreatedTS.startDate);
                        if (z == true) {
                            return;
                        }
                    }
                }
                if (!this.bool_isAMV) {
                    this.arr_displayGPI = [];
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;

                    this.getMainList();
                }
            },
            ShowDetails() {
                this.bool_showDetails = !this.bool_showDetails;
                this.seen = !this.seen;
                this.button.text = this.seen ? this.getLanguage["WLAJ"]["HDT"] : this.getLanguage["WLAJ"]["SDT"];

            },
            clearDateRangeFilter() {
                this.searchCreatedTS.startDate = this.getMonthStartDate();
                this.searchCreatedTS.endDate = this.getMonthEndDate();
            },

            formatMonth(date) {
                return moment(date).format('DD/MM')
            },
            formatTime(date) {
                return moment(date).format('hh:mm')
            },
            checkWholeNumber(num) {
                return !!(num % 1);
            },
            DisplayGPI(dID, signoffTS, currencyID, WhichAGI, CTS_from, CTS_to) {


                this.bool_fullLoading = true;
                var that = this;

                // this.current_no = 0;
                this.current_no = this.sp_no();


                if (dID != null) {
                    this.arr_displayGPI = [];
                    this.arr_displayGPI.push(dID);
                    var path = '';
                    path += "&f[I]=" + dID;

                    if (signoffTS) {
                        path += "&f.SOTS=" + this.parseDateToJsonString(signoffTS);
                    }
                    if (currencyID) {
                        path += "&f.CI=" + currencyID;
                    }
                    if (WhichAGI) {
                        path += "&f.AGI=" + WhichAGI;
                    }
                    if (CTS_from) {
                        path += "&f.CTS_from=" + this.parseDateToJsonString(CTS_from + 'T00:00:00.000');
                    }
                    if (CTS_to) {
                        path += "&f.CTS_to=" + this.parseDateToJsonString(CTS_to + 'T23:59:59.059');
                    }

                    this.getDataApi(`api/wlaj/getDetails?${path}`,
                        function (d, s) {
                            if (s) {
                                that.arr_displayGPI = d;
                            }
                            that.bool_fullLoading = false;
                        });

                }
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
        }
    };
</script>

    <style>
        .a {
            color: blue !important;
            cursor: pointer;
        }
        .float-left {
            float: left;
        }
        .tab-content .tab-pane {
            padding: 15px 0px;
        }
        .highlight {
            background-color: #FFCC66 !important;
        }
        .month-year-display {
            font-size: .76563rem !important;
            /*width: 200px !important;*/
        }

        .text-darkOrange {
            color: darkorange !important;
        }

        .text-red {
            color: rgb(229, 54, 54) !important;
        }
        .currency[abbr^="-"] {
            color: #ef5565 !important;
        }
        .text-green {
            color: #248f48 !important;
        }
        .cp-sticky {
            bottom: 0;
            text-align: inherit;
            background-color: #243147 !important;
            position: -webkit-sticky;
            position: sticky;
            z-index: 2;
        }
        .cp-positive {
            color: #20d27c !important;
        }
        .cp-negative {
            color: #ef5565 !important;
        }
        .cp-white {
            font-weight: normal !important;
            color: #FFFFFF !important;
        }
        .newDataRow {
            background-color: #FFFFDC !important;
        }
        .AdjustedRow[abbr^="-"] {
            background-color: #FFFFCC !important;
        }
    </style>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/WLAdjustment.vue